import React, {useEffect, useState} from 'react'
import {Form, Input, Button, message} from 'antd'
import apiRequest from '../../../hooks/ApiRequest'
import {toast} from 'react-toastify'
const DocumentUploadForm = props => {
  const {form, documentID, onSuccess,visible} = props
  const {getFieldDecorator} = form
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    if (documentID) {
      fetchDocument(documentID)
    } else {
      form.resetFields()
    }
  }, [visible])
  const fetchDocument = async id => {
    try {
      const res = await apiRequest(
        process.env.REACT_APP_BASE_URL_DOCUMENT + `/DocumentMaster/${id}`,
        'GET',
      )
      if (res.success) {
        const {name} = res?.data?.data
        form.setFieldsValue({
          name,
        })
      }
    } catch (err) {
      message.error('Failed to fetch document details')
    }
  }

  const handlSubmit = e => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (err) return
      setLoading(true)
      const payload = {
        ...values,
        ...(documentID
          ? {
              id: documentID,
              modifiedBy: localStorage.getItem('username'),
              modifiedAt: new Date(),
              active: true,
            }
          : {
              createdBy: localStorage.getItem('username'),
              createdAt: new Date(),
            }),
      }
      const url = documentID
        ? process.env.REACT_APP_BASE_URL_DOCUMENT +`/DocumentMaster/Update/${documentID}`
        : process.env.REACT_APP_BASE_URL_DOCUMENT + '/DocumentMaster'
      const method = 'POST'
      try {
        const response = await apiRequest(url, method, payload)
        if (response.success) {
          toast.success(
            documentID
              ? 'document updated successfully'
              : 'document added successfully',
          )
          if (onSuccess) onSuccess()
        } else {
          toast.error(response.error)
        }
      } catch (error) {
        toast.error('Something went wrong. Please try again.')
      } finally {
        setLoading(false)
      }
    })
  }
  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" form={form} onSubmit={handlSubmit}>
          <Form.Item label="Document Name">
            {getFieldDecorator('name', {
              rules: [{required: true, message: 'Document name is required'}],
            })(<Input placeholder="Enter Document Name" />)}
          </Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className="btn-success">
            {documentID ? 'Update Document' : 'Submit Document'}
          </Button>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(DocumentUploadForm)
